<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-card class="contenedor">
          <div slot="header">
            <strong>Nuevo Componente</strong>
          </div>
          <form data-vv-scope="formulario-componente">
            <b-row>
              <b-col lg="12" md="12" sm="12">
                <label>
                  Nombre
                  <span style="color: red;">
                    (*)
                  </span>
                </label>
                <b-form-input
                  v-model="componente.name"
                  id="nombre"
                  name="nombre"
                  data-vv-as=" "
                  v-validate="'required'"
                  type="text"
                />
                <span class="text-danger span-error small">
                  {{ errors.first('formulario-componente.nombre') }}
                </span>
              </b-col>
              <b-col lg="6" md="6" sm="12" class="mt-2">
                <label>
                  Numero de CAS
                </label>
                <b-form-input
                  v-model="componente.cas_number"
                  id="numero"
                  name="numero"
                  data-vv-as=" "
                  v-validate="{
                    rules: {
                      required: componente_id !== null,
                      check_cas_is_correct : 'formulario-componente.numero'
                    },
                  }"
                  :placeholder="placeHolderNumero"
                  type="text"
                />
                <span class="text-danger span-error small">
                  {{ errors.first('formulario-componente.numero') }}
                </span>
              </b-col>

              <b-col lg="6" md="6" sm="12" class="mt-2">
                <label>
                  Descripción CAS
                </label>
                <b-form-input
                    v-model="componente.cas_desc"
                    id="descripcion_cas"
                    name="descripcion_cas"
                    placeholder="Ejemplo: (METAL Y COMPUESTOS INSOLUBLES)"
                    type="text"
                />
              </b-col>

              <!-- Familias -->
              <b-col lg="6" md="6" sm="12" class="mt-2">
                <label for="familia_cas">
                  Familia
                </label>
                <el-select
                    id="familia_cas"
                    name="familia_cas"
                    multiple
                    filterable
                    clearable
                    v-model="componente.families"
                    placeholder="Seleccione una opción"
                    size="small"
                    remote
                >
                  <el-option
                      v-for="family in listFamilies"
                      :key="family.id"
                      :label="family.description"
                      :value="family.id"
                  />
                </el-select>
              </b-col>


              <b-col sm="12">
                <b-row class="text-center mt-4">
                  <b-col>
                    <b-button
                      v-if="!buscadorProducto"
                      to="/cas/componentes"
                      size="sm"
                      variant="secondary"
                      class="float-left"
                    >
                      <i class="fa fa-reply fa-lg"></i>
                      Volver
                    </b-button>

                    <slot name="close_modal"/>

                    <b-button @click="guardar" size="sm" variant="primary">
                      <i class="fa fa-floppy-o fa-lg"></i>
                      Guardar
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Swal from 'sweetalert2'

export default {
  props: {
    buscadorProducto: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: function () {
    return {
      componente_id: null,
      errorMsg: null,
    }
  },
  async created() {
    let self = this
    await this.getActivesFamilies();
    this.resetComponente()
    this.$validator.extend('check_cas_is_correct', {
      getMessage() {
        return self.errorMsg
      },
      validate(value) {
        const casBase = value.slice(0, -1);
        const reversedNumber = casBase.replace(/-/g, '').split('').reverse().join('');
        const sum = reversedNumber
            .split('')
            .map((digit, index) => parseInt(digit) * (index + 1))
            .reduce((acc, curr) => acc + curr, 0);
        const remainder = sum % 10;
        const result = casBase + remainder;

        // Verificar formato
        let regex = /^\d{2,7}-\d{2}-\d{1}$/;
        let isValid = regex.test(value);

        if (value.startsWith('AU') && self.componente.id){
          return true;
        }
        if (!isValid) {
          self.errorMsg =  'El CAS proporcionado no cumple con el formato.';
          return false;
        }

        if (result !== value) {
          self.errorMsg =  `El dígito de verificación es incorrecto. Debería ser ${remainder}.`;
          return false;
        }

        return true;
      },
    });


    if (this.$route.params.component_id !== undefined) {
      this.componente_id = this.$route.params.component_id
      await this.buscarComponente(this.componente_id)
    }

  },
  computed: {
    ...mapState('casFamily', ['listFamilies']),
    ...mapState('nuevocas', ['componente']),
    placeHolderNumero() {
      return this.componente_id == null
        ? 'Si no se especifica, se generará automáticamente.'
        : ''
    },
  },
  methods: {
    ...mapActions('casFamily', ['getActivesFamilies']),
    ...mapActions('nuevocas', [
      'buscarComponente',
      'crearComponente',
      'actualizarComponente',
    ]),
    ...mapMutations('nuevocas', ['resetComponente']),

    async guardar() {
      this.$validator
        .validateAll('formulario-componente')
        .then(async (result) => {
          if (result) {
            let msg = 'Esta seguro de guardar este componente?'
            if (
              this.componente.cas_number == '' ||
              this.componente.cas_number == undefined
            ) {
              msg =
                'No ha ingresado un numero de CAS esta seguro que desea que se genere uno automatico?'
            }
            await Swal.fire({
              title: 'Guardar Componente',
              text: msg,
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              cancelButtonText: 'Cancelar',
              confirmButtonText: 'Si',
            }).then(async (result) => {
              if (result.value) {
                if (this.componente_id !== null) {
                  await this.actualizarComponente(this.componente)
                    .then(() => {
                      this.$router.push('/cas/componentes')
                    })
                    .catch((e) => console.log(e))
                } else {
                  await this.crearComponente(this.componente)
                    .then(() => {
                      if (this.buscadorProducto) {
                        this.$emit('modalComponente')
                      } else {
                        this.$router.push('/cas/componentes')
                      }
                    })
                    .catch((e) => console.log(e))
                }
              }
            })
          }
        })
    },
  },
}
</script>
